import React, { useState } from 'react'
import {
  Button, Input
} from 'semantic-ui-react'
import { AppContext } from './../../../providers'

const SaveMessage = ({ save, close }) => {
  const { theme } = React.useContext(AppContext)
  const [name, setName] = useState('')

  const inputchangedHandler = (event) => {
    setName(event.target.value)
  }

  const onHandleSave = () => {
    save({ name })
  }

  const onHandleClose = () => {
    close()
  }

  return (
    <>
      <div id="builder">
        <Input
          label={{ icon: 'asterisk' }}
          labelPosition='right corner'
          type="text"
          placeholder='Description'
          onChange={inputchangedHandler}
          style={{ width: '100%', paddingBottom: '10px' }}
          value={name}
          autoFocus
        />
      </div>
      <div
        className="actions"
        style={{ width: '100%', textAlign: 'right', marginTop: '5px' }}
      >
        <Button inverted={theme.inverted} color={theme.button.primary} onClick={onHandleSave}>
          <i className="save icon"></i> Save
        </Button>
        <Button inverted={theme.inverted} color={theme.button.secondary} onClick={onHandleClose}>
          <i className="close icon"></i> Cancel
        </Button>
      </div>


    </>
  )
}

export default SaveMessage
